import {useQuery} from '@tanstack/react-query';
import {requestHost} from '../host/client';
import type {BgmCatalogItem} from '../../protocol/bgm-catalog';
export type {BgmCatalogItem} from '../../protocol/bgm-catalog';

export function useGetSharedAssetsApi(params:{tags?:number[]},_options?:{staleTime?:number;placeholderData?:(previousData:{data:BgmCatalogItem[]}|undefined)=>{data:BgmCatalogItem[]}|undefined}){
  return useQuery({queryKey:['waka-bgm-catalog'],staleTime:0,retry:false,select:result=>({data:params.tags?.length?result.data.filter(item=>params.tags!.every(tag=>item.tags.includes(tag))):result.data}),queryFn:async()=>{
    const result=await requestHost({method:'GET',path:'/__waka/bgm'});
    if(!result||typeof result!=='object'||!('data' in result)||!Array.isArray(result.data))throw new Error('배경음 목록을 확인하지 못했습니다.');
    const data=result.data as BgmCatalogItem[];
    if(data.some(item=>!item||typeof item.contentId!=='string'||typeof item.name!=='string'||typeof item.publicUrl!=='string'||!Array.isArray(item.tags)))throw new Error('배경음 원본 정보가 올바르지 않습니다.');
    return {data};
  }});
}
